import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import LogoutDropdown from "./LogoutButton";
import itiLogo from 'src/assets/icons/iti-logo.png';
import haryanaGovIcon from 'src/assets/icons/Emblem_of_Haryana.svg.png';

const Appbar = () => {
  const { t } = useTranslation();
  const isAuthenticated = Boolean(localStorage.getItem('token'));
  const role = localStorage.getItem('role');

  if (!isAuthenticated || !['iti', 'trainee', 'trainer'].includes(role)) {
    return null;
  }

  return (
    <header className="w-full top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="container mx-auto px-4 md:px-8 py-3">
        <div className="flex justify-between items-center gap-4">
          {/* Left: Haryana Gov Logo */}
              <img 
                alt="gov-logo" 
                src={haryanaGovIcon} 
                className="h-10 md:h-16 w-auto object-contain" 
              />   

          {/* Center: Title (Now in Primary Color) */}
          <h1 className="flex-1 text-center text-primary font-bold text-lg md:text-2xl leading-tight">
            {t('navbar.title')}
          </h1>

          <div className="flex items-center gap-4 md:gap-6">
            {/* ITI Logo - Big and Original Color */}
              <Link to="/" className="shrink-0">
            <img alt="iti-logo" src={itiLogo} className="h-10 md:h-10 object-contain" />
          </Link>
            
            {/* Vertical Divider */}
            <div className="h-10 w-[1px] bg-gray-200 hidden sm:block"></div>
            
            <LogoutDropdown />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Appbar;